const variants = {
  RECIPE_LIST_FILTER: "RECIPE_LIST_FILTER",
  RECIPE_SORTING: "RECIPE_SORTING",
  NEWS_SEARCH_PAGINATION: "NEWS_SEARCH_PAGINATION",
  SLIDER_CARD:'SLIDER_CARD',
  THREE_COLUMN_VIDEO : "THREE_COLUMN_VIDEO",
  formInputStyle_6_6: "formInputStyle_6_6",
  TWO_COLUMN_LINKS_BG_WHITE :"TWO_COLUMN_LINKS_BG_WHITE",
  TWO_COLUMN_LINKS_SMALL_TITLE : "TWO_COLUMN_LINKS_SMALL_TITLE",
  CONTACT_CARD_IMAGE : "CONTACT_CARD_IMAGE",
  TREND_RADAR_MOBILE_ACCORDION: "TREND_RADAR_CHART_MOBILE_SCREEN_ACCORDION",
  COCOA_LIFE_PILLER_DESCRIPTION: "COCOA_LIFE_PILLER_DESCRIPTION"
}

export const textThemes = ""

export default variants
